import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import './BrandOnboardingPanelTransition.scss';

// export const preloadImages = (...urls) => {
//   urls.filter(Boolean).forEach(url => {
//     const img = new Image();
//     img.src = url;
//   });
// };

export const preloadImages = (...urls) => {
  return new Promise(resolve => {
    const images = urls.filter(Boolean).map(url => {
      const img = new Image();
      img.src = url;
      return img;
    });

    let loadedCount = 0;
    images.forEach(img => {
      img.onload = () => {
        loadedCount++;
        if (loadedCount === images.length) resolve();
      };
      img.onerror = () => {
        loadedCount++;
        console.error(`Failed to preload image: ${img.src}`);
        if (loadedCount === images.length) resolve();
      };
    });
  });
};

const BrandOnboardingPanelTransition = ({ Panel, panelProps, isActive, onFadeOutEnd }) => {
  const node = useRef(null);
  const [mounted, setMounted] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    let timeoutId;

    if (isActive) {
      setFadeOut(false); // <- reset
      setMounted(true);
    } else {
      timeoutId = setTimeout(() => setFadeOut(true), 100);
    }

    /* cleanup – kill timeout if props change before it fires */
    return () => clearTimeout(timeoutId);
  }, [isActive]);

  const handleEnd = e => {
    if (e.target !== node.current) return; // ignore child events
    if (!isActive) {
      setMounted(false);
      onFadeOutEnd?.();
    }
  };

  if (!mounted) return null;
  else if (!Panel) return null;

  return (
    <div ref={node} className={cn('brand-onboarding-panel-transition', { 'fade-out': fadeOut })} onTransitionEnd={handleEnd}>
      <Panel {...panelProps} />
    </div>
  );
};

export default BrandOnboardingPanelTransition;
